module.exports = {["template-constructor-workspace-inside-block-widget-selector"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n    <div class="widget-selector">\n\n        <div class="widget" data-block-type="picture">\n	    	<div class="icon"></div>\n	        <div class="caption">Image</div>\n        </div>\n\n\n	    <div class="widget" data-block-type="text">\n		    <div class="icon"></div>\n		    <div class="caption">Text</div>\n	    </div>\n\n    </div>\n\n';
}
return __p;
},}